import i18n from 'src/i18n';

export const translateOutSideComponent = (value: string) =>
  i18n.t(value, value);
